/* RESPONSIBLE TEAM: team-data-foundations */

export function isSalesforceSandboxUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  try {
    let urlObj = new URL(url);
    let host = urlObj.hostname.toLowerCase();

    if (host.includes('test.salesforce.com')) {
      return true;
    }
    if (host.includes('.sandbox.my.salesforce.com')) {
      return true;
    }
    if (host.includes('--')) {
      return true;
    }
    if (host.startsWith('cs')) {
      return true;
    }

    return false;
  } catch {
    return false;
  }
}

export function getOAuthProviderFromTokenUrl(url: string): string {
  if (!url) {
    return 'invalid';
  }

  try {
    let urlObj = new URL(url);
    let host = urlObj.hostname.toLowerCase();

    if (host === 'api.hubapi.com' || host.endsWith('.api.hubapi.com')) {
      return 'hubspot';
    }

    if (host === 'app.attio.com' || host.endsWith('.attio.com')) {
      return 'attio';
    }

    if (
      host.endsWith('.salesforce.com') ||
      host === 'salesforce.com' ||
      host.endsWith('.force.com') ||
      host === 'force.com'
    ) {
      return 'salesforce';
    }

    return 'unsupported';
  } catch {
    return 'invalid';
  }
}
